/**
 * ThresholdInput parse/format helpers.
 */

export function formatThreshold(value: number): string {
  return Number.isFinite(value) ? String(value) : '0';
}

export function parseThreshold(raw: string): number {
  const trimmed = raw.trim();
  if (trimmed === '' || trimmed === '-' || trimmed === '.' || trimmed === '-.') {
    return 0;
  }
  const parsed = parseFloat(trimmed);
  return Number.isFinite(parsed) ? parsed : 0;
}

export const DECIMAL_PATTERN = /^-?\d*\.?\d*$/;
